@use 'mixins' as *;
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
$color-white: var(--color-white);
$color-google-background: var(--color-google-background);
$color-google-border: var(--color-google-border);
$color-google-text: var(--color-google-text);
$color-google-state: var(--color-google-state);
$color-google-shadow-dark: var(--color-google-shadow-dark);

.google-button {
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	-webkit-appearance: none;
	background-color: $color-google-background;
	background-image: none;
	border: 1px solid $color-google-border;
	-webkit-border-radius: 4px;
	border-radius: 4px;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	color: $color-google-text;
	cursor: pointer;
	font-family: 'Roboto', arial, sans-serif;
	font-size: 14px;
	height: 40px;
	letter-spacing: 0.25px;
	outline: none;
	overflow: hidden;
	padding: 0 12px;
	position: relative;
	text-align: center;
	-webkit-transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
	transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
	vertical-align: middle;
	white-space: nowrap;
	width: 100%;
	max-width: 400px;
	min-width: min-content;
	display: flex;
	align-items: center;
	justify-content: center;

	&:disabled {
		cursor: default;
		background-color: rgba($color-white, 0.38);
		border-color: rgba($color-google-text, 0.12);

		.google-button-contents {
			opacity: 38%;
		}

		.google-button-icon {
			opacity: 38%;
		}
	}

	&:not(:disabled):active .google-button-state,
	&:not(:disabled):focus .google-button-state {
		background-color: $color-google-state;
		opacity: 12%;
	}

	&:not(:disabled):hover {
		-webkit-box-shadow: 0 1px 2px 0 rgba($color-google-shadow-dark, 0.3),
			0 1px 3px 1px rgba($color-google-shadow-dark, 0.15);
		box-shadow: 0 1px 2px 0 rgba($color-google-shadow-dark, 0.3),
			0 1px 3px 1px rgba($color-google-shadow-dark, 0.15);

		.google-button-state {
			background-color: $color-google-state;
			opacity: 8%;
		}
	}
}

.google-button-icon {
	height: 20px;
	margin-right: 10px;
	min-width: 20px;
	width: 20px;
}

.google-button-content-wrapper {
	-webkit-align-items: center;
	align-items: center;
	display: flex;
	-webkit-flex-direction: row;
	flex-direction: row;
	-webkit-flex-wrap: nowrap;
	flex-wrap: nowrap;
	height: 100%;
	justify-content: center;
	position: relative;
	width: 100%;
}

.google-button-contents {
	-webkit-flex-grow: 0;
	flex-grow: 0;
	font-family: 'Roboto', arial, sans-serif;
	@include font-weight-medium;
	overflow: hidden;
	text-overflow: ellipsis;
	vertical-align: top;
}

.google-button-state {
	-webkit-transition: opacity 0.218s;
	transition: opacity 0.218s;
	bottom: 0;
	left: 0;
	opacity: 0;
	position: absolute;
	right: 0;
	top: 0;
}
